import { render } from "./EducationBlogCurriculum.vue?vue&type=template&id=b96aeba6&scoped=true"
import script from "./EducationBlogCurriculum.vue?vue&type=script&lang=js"
export * from "./EducationBlogCurriculum.vue?vue&type=script&lang=js"

import "./EducationBlogCurriculum.vue?vue&type=style&index=0&id=b96aeba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b96aeba6"]])

export default __exports__